<template>
  <v-alert :value="visible">
    <v-layout justify-end>
      <v-icon
        class="clickable"
        @click="hideAlert"
      >
        clear
      </v-icon>
    </v-layout>
    <div
      v-for="(element, index) in deleteActions"
      :key="index"
    >
      <h4 class="display-1 display-1_dark mb-3">
        {{ giftgiverAlert(element) }}
      </h4>
      <v-layout
        :wrap="$vuetify.breakpoint.smAndDown"
        class="mb-1"
      >
        <v-flex
          lg2
          md2
          sm12
        >
          <span class="fw-600 f-1">{{ $t('family_card.turn_off.reason') | addColons }}</span>
        </v-flex>
        <v-flex
          lg10
          md10
          sm12
        >
          <p class="mb-0 f-1">
            {{ element.explanation }}
          </p>
        </v-flex>
      </v-layout>
      <v-layout :wrap="$vuetify.breakpoint.smAndDown">
        <v-flex
          lg2
          md2
          sm12
        >
          <span class="fw-600 f-1">{{
            $t('giftgiver.remove.alert.giftgiver_info') | addColons
          }}</span>
        </v-flex>
        <v-flex
          lg10
          md10
          sm12
        >
          <p class="mb-0 f-1">
            {{ element?.gift_giver_data?.first_name }} {{ element?.gift_giver_data?.last_name }},
            <BaseEmail :email="element?.gift_giver_data?.email" />,
            <PhoneNumber :number="element?.gift_giver_data?.phone_number" />
          </p>
        </v-flex>
      </v-layout>
      <v-divider
        v-if="index !== deleteActions.length - 1"
        class="my-3"
      />
    </div>
  </v-alert>
</template>

<script>
import filters from '@/constants/filters';
import BaseEmail from '@/components/widgets/BaseEmail.vue';
import PhoneNumber from '@/components/widgets/PhoneNumber.vue';

export default {
    name: 'RemoveGiftGiverInfo',
    components: { BaseEmail, PhoneNumber },
    filters: { ...filters },
    props: {
        giftgiverInfo: {
            required: true
        }
    },
    data () {
        return {
            visible: null
        };
    },
    computed: {
        deleteActions () {
            let arr = [];
            if (this.giftgiverInfo) {
                arr = this.giftgiverInfo.filter((el) => el.description === 'delete');
            }
            if (arr.length > 0) {
                return arr.sort(function (a, b) {
                    return b.id - a.id;
                });
            }
            return false;
        }
    },
    created () {
        this.visible = this.deleteActions.length > 0;
    },
    methods: {
        hideAlert () {
            this.visible = false;
        },
        createdAtDate (time) {
            const date = new Date(time);
            return date.toLocaleDateString();
        },
        createdAtTime (time) {
            const date = new Date(time);
            return date.toLocaleTimeString();
        },
        giftgiverAlert (item) {
            const { user_first_name: firstName, user_last_name: lastName } = item || null;
            const fullName = `${firstName} ${lastName}`;
            return (
                this.$t('giftgiver.remove.alert.title') +
        ' ' +
        fullName +
        ' ' +
        this.$t('family_card.changelog.change_date', {
            date: this.createdAtDate(item.created_at),
            time: this.createdAtTime(item.created_at)
        })
            );
        }
    }
};
</script>

<style scoped></style>
